export default __webpack_public_path__ + "media/images/images/banner/banner-37-c1f61bc82758d74e327dffb92b8fda72.jpg";